// extracted by mini-css-extract-plugin
module.exports = {"TitleWrap":"style_TitleWrap__-toe9","Title":"style_Title__3rVxw","SubTitle":"style_SubTitle__pbXWB"};